import UserStore from './UserStore'

const setOldUser = (value: string) => {
  const userStore = new UserStore()
  userStore.setOldUser(value)
}

export default setOldUser